export const CREW_FILE_PRINT_SECTIONS = [
  { key: 'aiOverview', label: 'AI overview' },
  { key: 'atAGlance', label: 'At a glance' },
  { key: 'tenure', label: 'Tenure' },
  { key: 'personal', label: 'Personal' },
  { key: 'contact', label: 'Contact & address' },
  { key: 'availability', label: 'Availability & recruitment' },
  { key: 'physical', label: 'Physical / misc' },
  { key: 'certificates', label: 'Documents' },
  { key: 'medicals', label: 'Medicals' },
  { key: 'nextOfKin', label: 'Next of kin' },
  { key: 'allottees', label: 'Allottees' },
  { key: 'appraisals', label: 'Appraisals' },
  { key: 'feedback', label: 'Feedback' },
  { key: 'seaService', label: 'Sea service' },
  { key: 'documents', label: 'Other files' },
  { key: 'notes', label: 'Crew notes' },
] as const;

export type CrewFilePrintSectionKey = (typeof CREW_FILE_PRINT_SECTIONS)[number]['key'];

export type CrewFilePrintSectionSelection = Record<CrewFilePrintSectionKey, boolean>;

export function defaultCrewFilePrintSections(
  allSelected = true,
): CrewFilePrintSectionSelection {
  return Object.fromEntries(
    CREW_FILE_PRINT_SECTIONS.map((s) => [s.key, allSelected]),
  ) as CrewFilePrintSectionSelection;
}

export function isCrewFilePrintSectionKey(value: string): value is CrewFilePrintSectionKey {
  return CREW_FILE_PRINT_SECTIONS.some((s) => s.key === value);
}

export function parseCrewFilePrintSectionsParam(
  raw: string | null | undefined,
): CrewFilePrintSectionSelection {
  const all = defaultCrewFilePrintSections(true);
  if (!raw?.trim()) return all;
  const selected = new Set(
    raw
      .split(',')
      .map((s) => s.trim())
      .map((s) => (s === 'experience' ? 'tenure' : s))
      .filter(isCrewFilePrintSectionKey),
  );
  if (selected.size === 0) return all;
  return Object.fromEntries(
    CREW_FILE_PRINT_SECTIONS.map((s) => [s.key, selected.has(s.key)]),
  ) as CrewFilePrintSectionSelection;
}

export function crewFilePrintSectionsToParam(selection: CrewFilePrintSectionSelection): string {
  return CREW_FILE_PRINT_SECTIONS.filter((s) => selection[s.key])
    .map((s) => s.key)
    .join(',');
}

export function countSelectedCrewFilePrintSections(selection: CrewFilePrintSectionSelection): number {
  return CREW_FILE_PRINT_SECTIONS.filter((s) => selection[s.key]).length;
}
